export default __webpack_public_path__ + "static/media/logo-darkmode.1c830f26.svg";